export const greeting = () => {
  let hour = new Date().getHours();
  console.log(`the hour is ${hour}`);
  if (hour >= 6 && hour < 12) {
    return 'morning';
  } else if (hour >= 12 && hour < 18) {
    return 'afternoon';
  } else return 'evening';
};
